import { render, staticRenderFns } from "./DomainSingle.vue?vue&type=template&id=27916e5c&"
import script from "./DomainSingle.vue?vue&type=script&lang=js&"
export * from "./DomainSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27916e5c')) {
      api.createRecord('27916e5c', component.options)
    } else {
      api.reload('27916e5c', component.options)
    }
    module.hot.accept("./DomainSingle.vue?vue&type=template&id=27916e5c&", function () {
      api.rerender('27916e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DomainSingle.vue"
export default component.exports